import { cn } from '../../utils/cn';

type LoadingSpinnerProps = {
  className?: string;
};

export const LoadingSpinner = ({ className }: LoadingSpinnerProps) => {
  return (
    <div
      data-testid="loading-spinner"
      className={cn('mb-4 h-16 w-16 animate-spin rounded-full border-t-4 border-b-4 border-primary', className)}
    ></div>
  );
};
